import { useCallback, useMemo } from 'react';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import Button from '@rio-cloud/rio-uikit/Button';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { FormattedMessage, useIntl } from 'react-intl';
import { runInBackground } from '../../../configuration/setup/backgroundActions';
import { reportErrorToSentry } from '../../../configuration/setup/sentry';

export const CopyToClipboard = (props: { value: string }) => {
    const intl = useIntl();

    const onCopy = useCallback(
        () =>
            runInBackground(async () => {
                try {
                    await navigator.clipboard.writeText(props.value);
                    Notification.success(<FormattedMessage id="outboundOrderBook.common.copied" />, { timeout: 2000 });
                } catch (error) {
                    // We are not sure if this error ever happens. So, we didn't translat this string, yet. If
                    // we see this error in Sentry we should add a translation.
                    Notification.error('No permission to write to the clipboard');
                    reportErrorToSentry(error);
                }
            }),
        [props.value],
    );

    const copyLabel = useMemo(() => intl.formatMessage({ id: 'outboundOrderBook.common.copy' }), [intl]);

    return (
        <span className="white-space-nowrap">
            {props.value}
            <OverlayTrigger overlay={<Tooltip>{copyLabel}</Tooltip>}>
                <Button
                    iconOnly
                    iconName="rioglyph-duplicate"
                    className="rioglyph-align-baseline"
                    aria-label={copyLabel}
                    bsStyle={Button.MUTED}
                    bsSize={Button.SM}
                    variant={Button.VARIANT_LINK}
                    onClick={onCopy}
                />
            </OverlayTrigger>
        </span>
    );
};
